import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from 'router/PrivateRoute/PrivateRoute';
import SignInPage from './pages/SignInPage/SignInPage';
import RecoverPage from './pages/RecoverPage/RecoverPage';
import RedirectPage from './pages/RedirectPage/RedirectPage';
import RedirectIntegrationPage from './pages/RedirectIntegrationPage/RedirectIntegrationPage';
import UnlockPage from './pages/UnlockPage/UnlockPage';
import WelcomePage from './pages/WelcomePage/WelcomePage';
import DeviceRegistrationPage from './pages/DeviceRegistrationPage/DeviceRegistrationPage';
import ResetPage from './pages/ResetPage/ResetPage';
import UpdatePasswordPage from './pages/UpdatePasswordPage/UpdatePasswordPage';
import AuthContextProvider from './AuthContext';

const AuthContainer = () => {
  return (
    <AuthContextProvider>
      <Routes>
        <Route index element={<Navigate to="signin" replace />} />
        <Route path="signin" element={<SignInPage />} />
        <Route path="recover" element={<RecoverPage />} />
        <Route
          path="redirect/:status/:token?/:device?/:redirect?/:tenant?"
          element={<RedirectPage />}
        />
        <Route path="connector/redirect/ok" element={<RedirectIntegrationPage />} />
        <Route path="unlock/:hash" element={<UnlockPage />} />
        <Route
          path="updatepassword"
          element={
            <PrivateRoute>
              <UpdatePasswordPage />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="deviceregistration"
          element={
            <PrivateRoute>
              <DeviceRegistrationPage />
            </PrivateRoute>
          }
        ></Route>
        <Route path="welcome" element={<WelcomePage />} />
        <Route path="reset/:hash" element={<ResetPage />} />
        <Route path="*" element={<Navigate to="/auth/signin" replace />} />
      </Routes>
    </AuthContextProvider>
  );
};

export default AuthContainer;
